import { connect } from 'react-redux';
import { ResultsType } from '../../../state/reducers/results.types';

const mapState = ({ results }: { results: ResultsType }) => ({
  enterprise: results.snippets.enterprise,
  lawyer: results.snippets.professional,
  hasLegalBasis: !!results.snippets.legalBasis,
});

export const Connect = connect(mapState);
